import classNames from 'classnames';
import React from 'react';

import { DarkSkeleton } from '@eika/skeleton';

import './FieldSkeleton.scss';

interface Props {
    isNoteField?: boolean;
}

const FieldSkeleton: React.FC<Props> = ({ isNoteField = false }) => {
    return (
        <div className={classNames('field-skeleton__container', { 'field-skeleton__note-field': isNoteField })}>
            <div className="field-skeleton__label">
                <DarkSkeleton width="10%" height={14} />
            </div>
            <div className="field-skeleton__value">
                <DarkSkeleton height={16} />
            </div>
            {!isNoteField && (
                <div className="field-skeleton__additional-value">
                    <DarkSkeleton height={14} />{' '}
                </div>
            )}
        </div>
    );
};

export default FieldSkeleton;
